import { Injectable } from '@angular/core';
import { PaetepCfSignatureModel } from '../../../item-models/paetep-cf-signature.model';
import { FormBuilder, Validators } from '@angular/forms';
import { EdlCfBuilderItemFormGroup, EdlCfBuilderItemPartial, EdlCfGenericModel, IEdlCfBuilderGenericService, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { PaetepCfBuilderSignatureForm } from '../../forms/paetep-cf-builder-signature/paetep-cf-builder-signature-form.interface';
import { PaetepCfBuilderSignaturePartial } from '../../forms/paetep-cf-builder-signature/paetep-cf-builder-signature-partial.interface';
import { CustomFormSignatureType } from 'src/app/model/enum/observations/custom-forms/custom-form-signature-type.enum';
import { CommonValidators } from '@edl-development/edl-common';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfBuilderSignatureService implements IEdlCfBuilderGenericService<PaetepCfSignatureModel, PaetepCfBuilderSignatureForm, PaetepCfBuilderSignaturePartial> {

    constructor(private formBuilder: FormBuilder) {}

    public buildForm = ({
        model, 
        buildChildForm
    } : {
        model?: PaetepCfSignatureModel, 
        buildChildForm: (model: EdlCfGenericModel<any>) => EdlCfBuilderItemFormGroup<any>
    }): PaetepCfBuilderSignatureForm => {
        return this.formBuilder.nonNullable.group({
            title: [model?.title ?? '', [Validators.required, CommonValidators.emptyString(), Validators.maxLength(MAX_TITLE_LENGTH)]],
            option: [model?.option ?? CustomFormSignatureType.TARGET_USER, [Validators.required]]
        });
    }

    public buildModel = (
        form: PaetepCfBuilderSignaturePartial, 
        buildChildModel: (model: EdlCfBuilderItemPartial<any>) => EdlCfGenericModel<any>
    ): PaetepCfSignatureModel => {
        return {
            title: form.title ?? '',
            option: form.option ?? CustomFormSignatureType.TARGET_USER
        };
    }
}
